"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePrint = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const invoice_1 = require("../../../model/invoice");
const helpers_1 = require("../../../utils/helpers");
const form_for_1 = require("../../../widgets/form_for");
const moment = require("moment");
exports.InvoicePrint = {
    invoice: {},
    loading: true,
    fetch(id) {
        this.loading = true;
        invoice_1.InvoiceProvider.show(id).then((data) => {
            this.loading = false;
            this.invoice = data;
        });
    },
    link(id) {
        return `#/invoices/${id}/print`;
    },
    renderInvoiceTitle() {
        return (0, mithril_1.default)("div", { style: "text-align: center;" }, (0, mithril_1.default)("h2", `Facture #${this.invoice.reference}`), (0, mithril_1.default)("p", "Le ", moment(this.invoice.created_at).format("LL")), (0, mithril_1.default)("hr"));
    },
    renderClientData() {
        return (0, mithril_1.default)("div", (0, mithril_1.default)("div", this.invoice.client.id), (0, mithril_1.default)("div", this.invoice.client.name), (0, helpers_1.ifTrue)(this.invoice.client.siret, (0, mithril_1.default)("div", this.invoice.client.siret)), (0, mithril_1.default)("div", this.invoice.client.status), (0, mithril_1.default)("div", this.invoice.client.address), (0, mithril_1.default)("div", (0, mithril_1.default)("span", this.invoice.client.postal_code), (0, mithril_1.default)("span", " "), (0, mithril_1.default)("span", this.invoice.client.city)));
    },
    renderSesameData() {
        return (0, mithril_1.default)("div", (0, mithril_1.default)("strong", "Centre Sésame"), (0, mithril_1.default)("p", mithril_1.default.trust(app_1.App.getSettings("address", "").replace(/\n/g, "<br>"))));
    },
    oncreate(node) {
        let id = node.attrs.invoice_id;
        this.fetch(id);
    },
    renderTable() {
        return (0, mithril_1.default)("table", { class: "table" }, (0, mithril_1.default)("thead", (0, mithril_1.default)("td", "Description"), (0, mithril_1.default)("td", "Total HT"), (0, mithril_1.default)("td", "TVA"), (0, mithril_1.default)("td", "Total TTC")), this.invoice.lines.map((elm) => {
            return (0, mithril_1.default)("tr", (0, mithril_1.default)("td", elm.description), (0, mithril_1.default)("td", (0, helpers_1.moneyToString)(elm.value)), (0, mithril_1.default)("td", (0, helpers_1.moneyToString)(elm.vat)), (0, mithril_1.default)("td", (0, helpers_1.moneyToString)((0, helpers_1.moneyAdd)(elm.value, elm.vat))));
        }));
    },
    renderPaymentScheme() {
        return [
            (0, mithril_1.default)("h2", "Calendrier des paiements"),
            (0, mithril_1.default)("p", `À date du ${moment().format("DD/MM/YYYY HH:MM (Z)")}`),
            (0, mithril_1.default)("table", (0, mithril_1.default)("thead", (0, mithril_1.default)("td", "Date"), (0, mithril_1.default)("td", "Montant (TTC)"), (0, mithril_1.default)("td", "Statut")), this.invoice.payments.map((p) => {
                return (0, mithril_1.default)("tr", (0, mithril_1.default)("td", moment(p.due_at).format("DD/MM/YYYY")), (0, mithril_1.default)("td", (0, helpers_1.moneyToString)(p.value)), (0, mithril_1.default)("td", p.paid ? "PAYÉ" : "NON PAYÉ"));
            }))
        ];
    },
    totalHT() {
        let value = (0, helpers_1.money)();
        this.invoice.lines.forEach((x) => {
            value = (0, helpers_1.moneyAdd)(value, x.value);
        });
        return value;
    },
    totalVAT() {
        let vat = (0, helpers_1.money)();
        this.invoice.lines.forEach((x) => {
            vat = (0, helpers_1.moneyAdd)(vat, x.vat);
        });
        return vat;
    },
    renderSummary() {
        let value = this.totalHT();
        let vat = this.totalVAT();
        let total = (0, helpers_1.moneyAdd)(value, vat);
        return (0, mithril_1.default)("table", (0, mithril_1.default)("tr", (0, mithril_1.default)("td", { colspan: 2 }), (0, mithril_1.default)("td", "TOTAL HT"), (0, mithril_1.default)("td", (0, helpers_1.moneyToString)(value))), (0, mithril_1.default)("tr", (0, mithril_1.default)("td", { colspan: 2 }), (0, mithril_1.default)("td", `TVA`), (0, mithril_1.default)("td", (0, helpers_1.moneyToString)(vat))), (0, mithril_1.default)("tr", (0, mithril_1.default)("td", { colspan: 2 }), (0, mithril_1.default)("td", (0, mithril_1.default)("strong", "Net à Payer")), (0, mithril_1.default)("td", (0, helpers_1.moneyToString)(total))));
    },
    renderPrintToolbox() {
        return (0, mithril_1.default)("div", { class: "print-toolbox" }, (0, mithril_1.default)("button", {
            class: "button",
            onclick: () => { print(); }
        }, (0, helpers_1.iconSpan)("fa-print"), (0, mithril_1.default)("span", "Imprimer")));
    },
    view(_node) {
        if (this.loading) {
            return (0, mithril_1.default)("div", { class: "content container", style: "height: 100%; overflow-y: auto; " }, this.renderPrintToolbox(), (0, mithril_1.default)("div", { style: "text-align: center;" }, "Chargement..."));
        }
        else {
            return (0, mithril_1.default)("div", { class: "content container", style: "height: 100%; overflow-y: auto; " }, this.renderPrintToolbox(), this.renderInvoiceTitle(), (0, form_for_1.columns)(this.renderSesameData(), this.renderClientData()), this.renderTable(), (0, form_for_1.columns)((0, mithril_1.default)("div"), this.renderSummary()), this.renderPaymentScheme());
        }
    }
};
